import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  borderRight: 0,
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
    // height: '100%', // Ensure the drawer takes the full height
  },
  [`& .${drawerClasses.root}, .${drawerClasses.paper}`]: {
    borderRight: 0
  },
});

export default function SideMenu({ currentPage }) {
  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: '#ededed',

        },
      }}
    >
      <MenuContent
        sx={{
          marginTop: 7,
          marginBottom: 2,
          marginX: 1,
          borderRadius: 2,
          backgroundColor: '#fff'
        }}
        currentPage={currentPage}
      />
    </Drawer>
  );
}
